"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFunction = void 0;
const isFunction = (fn) => {
    return typeof fn === 'function';
};
exports.isFunction = isFunction;
//# sourceMappingURL=isFunction.js.map